
export const AppLocalesDefinition: LocaleDefinition[] = [
    { locale: "pt-BR", flag: "brazil.png", name: "Português" },
    { locale: "es-ES", flag: "spain.png", name: "Español" },
    { locale: "en-US", flag: "usa.png", name: "English" }
];

export const AppDefaultLocale = "pt-BR";

export const AppLocales = AppLocalesDefinition.map((v) => v.locale);

export const AppGetLocaleFlag = (locale: string) => AppLocalesDefinition.find(p => p.locale == locale)?.locale;

export const AppCheckCompatibleLanguage = (lang: string) => {
    if (!AppLocales.includes(lang)) {
        if (lang == "en") lang = "en-US";
        else if (lang == "es") lang = "es-ES";
        else lang = "pt-BR";
    }
    return lang;
};